import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: '100%',
    height: 'auto',
  },
  path: {
    fill: '#F15060',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 401.6 60.7"
    >
      <path
        className={classes.path}
        d="M114.8,59.1V56c0-0.5,0.1-1,0.3-1.5l19.4-53.3c0.1-0.4,0.5-0.6,0.9-0.6h8c0.7,0,1.1,0.7,0.9,1.3l-21,57.6
        c-0.1,0.4-0.5,0.6-0.9,0.6h-6.7C115.2,60.1,114.8,59.7,114.8,59.1z M147.7,60.1h6.7c0.4,0,0.8-0.2,0.9-0.6l21-57.6
        c0.2-0.6-0.2-1.3-0.9-1.3h-8c-0.4,0-0.8,0.2-0.9,0.6L147,54.5c-0.2,0.5-0.3,1-0.3,1.5v3.1C146.7,59.7,147.2,60.1,147.7,60.1z
        M91.5,60.1h6.3c0.5,0,0.9-0.4,0.9-0.9V56c0-0.5-0.1-1-0.3-1.5L79.1,1.2c-0.1-0.4-0.5-0.6-0.9-0.6H74c-0.4,0-0.8,0.2-0.9,0.6
        L53.7,54.5c-0.2,0.5-0.3,1-0.3,1.5v3.1c0,0.5,0.4,0.9,0.9,0.9h6.3c0.4,0,0.8-0.2,0.9-0.6l14.5-39.8l14.5,39.8
        C90.8,59.8,91.1,60.1,91.5,60.1z M287,60.1h4c0.5,0,0.9-0.4,0.9-0.9l0-57.6c0-0.5-0.4-0.9-0.9-0.9h-6.8c-0.5,0-0.9,0.4-0.9,0.9v39.3
        L255.8,1.5c-0.4-0.6-1.1-0.9-1.8-0.9h-3.7c-0.5,0-0.9,0.4-0.9,0.9v57.6c0,0.5,0.4,0.9,0.9,0.9h6.8c0.5,0,0.9-0.4,0.9-0.9V20.3
        l27.2,38.8C285.6,59.7,286.3,60.1,287,60.1z M202.7,32.6h20.4c0.5,0,0.9-0.4,0.9-0.9v-6.8c0-0.5-0.4-0.9-0.9-0.9l-20.4,0V9.2h23.8
        c0.5,0,0.9-0.4,0.9-0.9V1.5c0-0.5-0.4-0.9-0.9-0.9H195c-0.5,0-0.9,0.4-0.9,0.9v57.6c0,0.5,0.4,0.9,0.9,0.9h31.5
        c0.5,0,0.9-0.4,0.9-0.9v-6.8c0-0.5-0.4-0.9-0.9-0.9h-23.8V32.6z M376.8,32.6h20.4c0.5,0,0.9-0.4,0.9-0.9v-6.8c0-0.5-0.4-0.9-0.9-0.9
        l-20.4,0V9.2h23.8c0.5,0,0.9-0.4,0.9-0.9V1.5c0-0.5-0.4-0.9-0.9-0.9h-31.5c-0.5,0-0.9,0.4-0.9,0.9v57.6c0,0.5,0.4,0.9,0.9,0.9h31.5
        c0.5,0,0.9-0.4,0.9-0.9v-6.8c0-0.5-0.4-0.9-0.9-0.9h-23.8V32.6z M26.2,9.2h16.6c0.5,0,0.9-0.4,0.9-0.9V1.5c0-0.5-0.4-0.9-0.9-0.9
        H0.9C0.4,0.6,0,1,0,1.5l0,6.8c0,0.5,0.4,0.9,0.9,0.9h16.6v49.9c0,0.5,0.4,0.9,0.9,0.9h6.8c0.5,0,0.9-0.4,0.9-0.9V9.2z M322.3,18.5
        c0-5.4,4.3-9.8,9.7-9.8c5.1,0,9.2,3.9,9.7,8.8c0,0.5,0.5,0.9,0.9,0.9h6.8c0.5,0,1-0.5,0.9-1C349.8,7.7,341.8,0,332,0h0
        c-10.1,0-18.4,8.2-18.4,18.4v23.9c0,10.1,8.2,18.4,18.4,18.4h0c9.8,0,17.8-7.7,18.3-17.4c0-0.5-0.4-1-0.9-1h-6.8
        c-0.5,0-0.9,0.4-0.9,0.9c-0.4,5-4.6,8.8-9.7,8.8c-5.4,0-9.7-4.4-9.7-9.8V18.5z"
      />
    </svg>
  );
};
